module.exports = __webpack_public_path__ + "static/media/Studies_Logo.8a4c639a.svg";